"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tierLimitations = void 0;
exports.tierLimitations = {
    private: {
        services: 1,
        queues: 1,
        schedules: 1,
        inventory: 1,
        products: 3,
        forms: 0,
        displayApp: false,
        kioskApp: false,
        scannerApp: false,
        brandCustomisation: false,
        ticketPrinting: false,
    },
    pro_monthly: {
        services: 5,
        inventory: 5,
        forms: 5,
        queues: 3,
        schedules: 3,
        products: 20,
        displayApp: true,
        kioskApp: true,
        scannerApp: true,
        brandCustomisation: true,
        ticketPrinting: false,
    },
    pro_annual: {
        services: 5,
        inventory: 5,
        forms: 5,
        queues: 3,
        schedules: 3,
        products: 20,
        displayApp: true,
        kioskApp: true,
        scannerApp: true,
        brandCustomisation: true,
        ticketPrinting: false,
    },
    enterprise_monthly: {
        services: Number.MAX_SAFE_INTEGER,
        inventory: Number.MAX_SAFE_INTEGER,
        forms: Number.MAX_SAFE_INTEGER,
        queues: Number.MAX_SAFE_INTEGER,
        schedules: Number.MAX_SAFE_INTEGER,
        products: Number.MAX_SAFE_INTEGER,
        displayApp: true,
        kioskApp: true,
        scannerApp: true,
        brandCustomisation: true,
        ticketPrinting: true,
    },
    enterprise_annual: {
        services: Number.MAX_SAFE_INTEGER,
        inventory: Number.MAX_SAFE_INTEGER,
        forms: Number.MAX_SAFE_INTEGER,
        queues: Number.MAX_SAFE_INTEGER,
        schedules: Number.MAX_SAFE_INTEGER,
        products: Number.MAX_SAFE_INTEGER,
        displayApp: true,
        kioskApp: true,
        scannerApp: true,
        brandCustomisation: true,
        ticketPrinting: true,
    },
};
//# sourceMappingURL=tierLimitations.js.map